
import React from 'react';
import { CheckCircle2, AlertTriangle, AlertOctagon, HelpCircle } from 'lucide-react';

type HealthStatus = 'healthy' | 'degraded' | 'unknown' | 'down';

interface HealthIndicatorProps {
    status: HealthStatus | string;
    showLabel?: boolean;
}

export const HealthIndicator: React.FC<HealthIndicatorProps> = ({
    status,
    showLabel = true
}) => {
    const normalizedStatus = (status?.toLowerCase() || 'unknown') as HealthStatus;

    const config = {
        healthy: {
            color: 'text-green-500',
            bgColor: 'bg-green-500/10',
            borderColor: 'border-green-500/20',
            icon: CheckCircle2,
            label: 'Healthy'
        },
        degraded: {
            color: 'text-yellow-500',
            bgColor: 'bg-yellow-500/10',
            borderColor: 'border-yellow-500/20',
            icon: AlertTriangle,
            label: 'Degraded'
        },
        down: {
            color: 'text-red-500',
            bgColor: 'bg-red-500/10',
            borderColor: 'border-red-500/20',
            icon: AlertOctagon,
            label: 'Down'
        },
        unknown: {
            color: 'text-gray-500',
            bgColor: 'bg-gray-500/10',
            borderColor: 'border-gray-500/20',
            icon: HelpCircle,
            label: 'Unknown'
        }
    };

    const { color, bgColor, borderColor, icon: Icon, label } = config[normalizedStatus] || config.unknown;

    return (
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border ${bgColor} ${borderColor}`}>
            <Icon className={`h-4 w-4 ${color}`} />
            {showLabel && (
                <span className={`text-sm font-medium ${color}`}>
                    {label}
                </span>
            )}
        </div>
    );
};
